module.exports = __webpack_public_path__ + "static/img/tongguo2.fa7dffc5.png";